export default function install(Vue) {
  if (install.installed) return;
  install.installed = true;

  Vue.prototype.tips = function (text = '', time = 2000) {
    try {
      this.$vux.toast.show({
        text,
        time,
        type: 'text'
      });
    } catch (err) {
      console.debug(err, 'err');
    }
  };
}



// WEBPACK FOOTER //
// ./src/plugins/EasyCallPlugin.js